import config from '@/config';
import { HOMEPAGE_BASE_PATH } from '@/logic/main/constants';
import { LogicContext } from '@/logic/main/types';

export const fetchPreviousPageInfo = async (context: LogicContext) => {
  const basePath = config.base_path || HOMEPAGE_BASE_PATH;
  const previousPageArray = context.previousPageArray;

  if (previousPageArray?.length) {
    const history = [...previousPageArray];

    const path = history.pop()?.pagePath || basePath;

    return {
      path: path,
      previousPageArray: history,
      mainLayoutPath: path,
    };
  }

  return {
    path: basePath,
    mainLayoutPath: basePath,
  };
};
